import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './Autocomplete.css';
import Autosuggest from 'react-autosuggest';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding, faUser } from '@fortawesome/free-solid-svg-icons';
import CompanyContext from '../../auth/CompanyContext';

const reactStringReplace = require('react-string-replace');
const loadingImg =
    "https://cdn.auth0.com/blog/auth0-react-sample/assets/loading.svg";

class Autocomplete extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.abortController = null;

        this.state = {
            value: this.props.value != null ? this.props.value : '',
            suggestions: [],
            isLoading: false,
            showHistory: this.props.showHistory || false,
            enableHistory: this.props.enableHistory || false,
            selectedValue: this.props.value != null ? this.props.value : null
        };
        this.timeout = this.props.timeout || 100;
        this.lastRequestId = null;
    }

    componentDidMount() {
        if (this.props.handleCallback != null) this.props.handleCallback(this.clear);
    }

    getSuggestionValue = (suggestion) => {
        return { sec: suggestion.sec, latest: suggestion.latest };
    }

    parseDate = (date) => {
        return parseInt(date.substr(0, 2)) + '/' + date.substr(4, 2)
    }

    toggleHistory = () => {
        this.setState({ showHistory: !this.state.showHistory })
    }

    renderSuggestion = (suggestion) => {
        const value = this.state.value;
        const isContact = Boolean(suggestion.contactGUID);

        return (
            <div className="suggestionContainer">
                <div className="suggestionIconRow">
                    <FontAwesomeIcon
                        icon={isContact ? faUser : faBuilding}
                        className="suggestionIcon"
                    />
                    <div className="suggestionContent">
                        {isContact ? (
                            <>
                                {suggestion.contactData['Contact Name'] && (
                                    <div className="suggestionName">
                                        {reactStringReplace(suggestion.contactData['Contact Name'], value, (match, i) => (
                                            <span key={i} className="suggestionFound">{match}</span>
                                        ))} {suggestion.active ? '' : <span className='searchResultsSmall'>(Inactive)</span>}
                                    </div>
                                )}
                                <div className="suggestionDetails">
                                    {suggestion.contactData['Email Address'] && (
                                        <span className="pr-3 font-weight-normal">
                                            {reactStringReplace(suggestion.contactData['Email Address'], value, (match, i) => (
                                                <span key={i} className="suggestionFound">{match}</span>
                                            ))}
                                        </span>
                                    )}
                                    {suggestion.contactData['Title'] && (
                                        <span className="pr-3 font-weight-normal">
                                            {reactStringReplace(suggestion.contactData['Title'], value, (match, i) => (
                                                <span key={i} className="suggestionFound">{match}</span>
                                            ))}
                                        </span>
                                    )}
                                </div>
                                <div className="suggestionDetails">
                                    {suggestion.contactData['Phone Number'] && (
                                        <span className="pr-3 font-weight-normal">
                                            {reactStringReplace(suggestion.contactData['Phone Number'], value, (match, i) => (
                                                <span key={i} className="suggestionFound">{match}</span>
                                            ))}
                                        </span>
                                    )}
                                </div>
                                <div className='suggestionDetails font-weight-bold'>
                                    {reactStringReplace(suggestion.name, value, (match, i) => (
                                        <span key={i} className="suggestionFound">{match}</span>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div className="suggestionName">
                                {reactStringReplace(suggestion.name, value, (match, i) => (
                                    <span key={i} className="suggestionFound">{match}</span>
                                ))}
                                {suggestion.dba && (
                                    <span className='searchResultsSmall'> (DBA {reactStringReplace(suggestion.dba, value, (match, i) => (
                                        <span key={i} className="suggestionFound">{match}</span>
                                    ))})</span>
                                )}
                            </div>
                        )}
                        <div className="suggestionDetails">
                            SEC#: <strong>{reactStringReplace(suggestion.sec, value, (match, i) => (
                                <span key={i} className="suggestionFound">{match}</span>
                            ))}</strong>
                            &nbsp; | Organization CRD#: <strong>{reactStringReplace(suggestion.organization, value, (match, i) => (
                                <span key={i} className="suggestionFound">{match}</span>
                            ))}</strong>
                            {(suggestion.earliest && suggestion.latest) && (
                                <>&nbsp; | Months Present: <strong>{this.parseDate(suggestion.earliest)} - {this.parseDate(suggestion.latest)}</strong></>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    loadSuggestions(value) {
        if (value.toString().length < 3) return;

        // Cancel debounce
        if (this.lastRequestId !== null) {
            clearTimeout(this.lastRequestId);
        }

        // Cancel previous fetch
        if (this.abortController) {
            this.abortController.abort();
        }

        // Set new timeout for debounce
        this.lastRequestId = setTimeout(() => {
            const json_request = JSON.stringify({
                query: value,
                showContacts: this.props.showContacts ?? true,
                showCompanies: this.props.showCompanies ?? true
            });

            // Create a new controller for this fetch
            this.abortController = new AbortController();
            const signal = this.abortController.signal;

            this.setState({ isLoading: true }, () => {
                fetch('/api/search/', {
                    method: 'POST',
                    body: json_request,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken,
                        'X-Database': this.context.company
                    },
                    signal
                })
                    .then(results => results.json())
                    .then(results => {
                        this.setState({
                            suggestions: results,
                            isLoading: false
                        });
                    })
                    .catch(err => {
                        if (err.name !== 'AbortError') {
                            console.error('Autocomplete fetch error:', err);
                            this.setState({ isLoading: false });
                        }
                    });
            });
        }, this.timeout);
    }

    onChange = (event, { newValue }) => {
        if (newValue.sec) newValue = newValue.sec;
        if (this.state.selectedValue != null && this.state.selectedValue !== '' && this.state.value != null && this.state.value !== '') {
            newValue = '';
            this.setState({
                value: String(newValue || ''),
                selectedValue: null
            }, () => {
                if (this.props.cb != null) this.props.cb(newValue);
                this.triggerOnSelect({ name: '', sec: '', organization: '' });
            })
        } else {
            if (this.props.cb != null) this.props.cb(newValue);
            this.setState({
                value: String(newValue || '')
            });
        }
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    callback = () => {
        this.setState({
            value: this.props.value != null ? this.props.value : ''
        });
    }

    triggerOnSelect = (selection) => {
        if (typeof this.props.onSelect === 'function') {
            this.props.onSelect(selection, this.callback);
        }
    }

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        console.log('suggestion', suggestion, suggestionValue);
        if (suggestion.contactGUID && this.props.newPage) {
            this.props.history.push({
                pathname: '/contacts/' + suggestion.contactGUID,
            });
            this.triggerOnSelect(suggestion);
            this.setState({
                value: '',
                selectedValue: this.props.clearOnSelect ? '' : suggestion.name
            });
        } else {
            if (this.props.newPage) this.props.history.push({
                pathname: '/demographics/' + suggestionValue.sec,
                state: suggestionValue.latest != null ? { currentDate: String(suggestionValue.latest).substr(-6) } : {}
            });
            this.triggerOnSelect(suggestion);
            this.setState({
                value: '',
                selectedValue: this.props.clearOnSelect ? '' : suggestion.name
            });
        }
    }

    clear = () => {
        this.setState({
            value: '',
            selectedValue: ''
        });
    }

    showPlaceholder = () => {
        if (this.props.showCompanies && !this.props.showContacts) {
            return "Company Search";
        } else if (!this.props.showCompanies && this.props.showContacts) {
            return "Contact Search";
        } else {
            return "Company/Contact Search";
        }
    }

    render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: ("placeholder" in this.props && this.props.placeholder !== "") ? this.props.placeholder : this.showPlaceholder(),
            value: String(value || ''), // ensure it's a string
            autoComplete: "off",
            // ['data-lpignore']: "true",
            onChange: this.onChange
        };

        return (
            <div className="searchContainer">
                {this.state.isLoading ? <div className="searchLoader"><img src={loadingImg} alt="Loading..." /></div> : <></>}
                <Autosuggest
                    clientToken={this.props.clientToken}
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    onSuggestionSelected={this.onSuggestionSelected}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    inputProps={inputProps}
                    className="autosuggest"
                />
                {/* {(this.props.enableHistory) ?
          <Button
            title="Enable/Disable Historical Search"
            onClick={this.toggleHistory}
            color="link"
            className={"btn-outline autocompleteHistory " + ((this.state.showHistory) ? "text-primary" : "text-muted")}>
            <FontAwesomeIcon icon={faHistory} />
          </Button> : <></>} */}
            </div>
        );

    }
}

export default Autocomplete;
